module.exports = __webpack_public_path__ + "img/HZ-S4014.87f8b7c5.jpg";